const APP_TITLE_PREFIX = 'Jurat Notary eJournal';

const routeTitles = [
  { pattern: /^\/$/, title: 'Dashboard' },
  { pattern: /^\/login\/?$/, title: 'Login' },
  { pattern: /^\/signup\/?$/, title: 'Sign Up' },
  { pattern: /^\/forgot-password\/?$/, title: 'Forgot Password' },
  { pattern: /^\/view-signing\/?$/, title: 'View Signing' },
  { pattern: /^\/verify-document\/?$/, title: 'Verify Document' },
  { pattern: /^\/errors\/404\/?$/, title: 'Not Found' },
  { pattern: /^\/errors\/500\/?$/, title: 'Server Error' },
  { pattern: /^\/notary\/journal\/?$/, title: 'Journal' },
  { pattern: /^\/notary\/drafts\/?$/, title: 'Saved Drafts' },
  { pattern: /^\/notary\/signing\/success\/?$/, title: 'Entry Complete' },
  {
    pattern: /^\/notary\/signing\/practice-module\/?$/,
    title: 'Practice Module'
  },
  { pattern: /^\/notary\/signing(\/[^/]+)?\/?$/, title: 'New Entry' },
  { pattern: /^\/notary\/practice\/?$/, title: 'Practice' },
  { pattern: /^\/notary\/reporting\/?$/, title: 'Journal Exports' },
  { pattern: /^\/account\/user-profile\/?$/, title: 'User Profile' },
  { pattern: /^\/account\/notary-profile\/?$/, title: 'Notary Commission' },
  { pattern: /^\/account\/verification\/?$/, title: 'Verification' },
  { pattern: /^\/account\/devices\/?$/, title: 'Devices' },
  { pattern: /^\/account\/delete-account\/?$/, title: 'Delete Account' },
  { pattern: /^\/library\/document-types\/?$/, title: 'Document Types' },
  {
    pattern: /^\/library\/favorite-locations\/?$/,
    title: 'Favorite Locations'
  },
  { pattern: /^\/library\/signing-packages\/?$/, title: 'Signing Packages' },
  {
    pattern: /^\/library\/master-client\/archived\/?$/,
    title: 'Archived Clients'
  },
  { pattern: /^\/library\/master-client\/?$/, title: 'My Clients' },
  { pattern: /^\/knowledge-center\/faqs\/?$/, title: 'FAQs' },
  { pattern: /^\/knowledge-center\/notarygpt\/?$/, title: 'NotaryGPT' },
  { pattern: /^\/extra\/feature-request\/?$/, title: 'Feature Requests' },
  { pattern: /^\/extra\/badges\/?$/, title: 'Badges' },
  { pattern: /^\/extra\/affiliate-program\/?$/, title: 'Affiliate Program' },
  { pattern: /^\/billing\/subscriptions\/?$/, title: 'Subscriptions' },
  { pattern: /^\/billing\/payment-history\/?$/, title: 'Payment History' },
  { pattern: /^\/billing\/payment-method\/?$/, title: 'Payment Methods' },
  { pattern: /^\/_admin\/password\/?$/, title: 'Password Access' }
];

export const getPageTitle = pathname => {
  const normalizedPath = pathname || '/';
  const match = routeTitles.find(route => route.pattern.test(normalizedPath));
  return match ? match.title : 'Not Found';
};

export const buildDocumentTitle = pathname =>
  `${APP_TITLE_PREFIX} | ${getPageTitle(pathname)}`;

export default buildDocumentTitle;
